module.exports = __webpack_public_path__ + "static/media/pers-3.ed81972a.jpg";